//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import { mapState } from "vuex";

  export default {
    name: "Direct",
    async fetch() {
      await Promise.all([ 
        this.$store.dispatch('pagesStore/getPage', 'direct')
      ])
    },
    components: {
      Paywall: () => import('~/components/payment/module.vue'),
      directSectionCategories: () => import('~/components/content/direct/sections/directSectionCategories.vue'),
      directSectionTop: () => import('~/components/content/direct/sections/directSectionTop.vue'),
      directSectionTopSummer: () => import('~/components/content/direct/sections/directSectionTopSummer.vue'),
      directSectionPromotion: () => import('~/components/content/direct/sections/directSectionPromotion.vue'),
      directSectionFilms: () => import('~/components/content/direct/sections/directSectionFilms.vue'),
      directSectionExtras: () => import('~/components/content/direct/sections/directSectionExtras.vue'),
      directSectionDevices: () => import('~/components/content/direct/sections/directSectionDevices.vue'),
      directSectionFaq: () => import('~/components/content/direct/sections/directSectionFaq.vue'),
    },
    mounted() {
      setTimeout(() => {
        document.documentElement.style.scrollSnapType = 'y mandatory'
        document.documentElement.style.scrollPadding = 'var(--header-height)'
      }, 50)
    },
    head() {
      return {
        title: this.pages.direct && this.pages.direct.seo
        ? this.pages.direct.seo.title
        : "Direct | Meiden van Holland",
        meta: [
          {
            hid: "title",
            name: "title",
            content: this.pages.direct && this.pages.direct.seo
            ? this.pages.direct.seo.title
            : "Direct | Meiden van Holland",
          },
          {
            hid: "og:title",
            name: "og:title",
            content: this.pages.direct && this.pages.direct.seo
            ? this.pages.direct.seo.title
            : "Direct | Meiden van Holland",
          },
          {
            hid: "description",
            name: "description",
            content: this.pages.direct && this.pages.direct.seo
            ? this.pages.direct.seo.description
            : "Kijk goedkoop en onbeberkt sexfilms met Meiden van Holland Direct. ACTIE: 3 maanden €9,99 voor 100% Geile amateursex.",
          },
          {
            hid: "og:description",
            name: "og:description",
            content: this.pages.direct && this.pages.direct.seo
            ? this.pages.direct.seo.description
            : "Kijk goedkoop en onbeberkt sexfilms met Meiden van Holland Direct. ACTIE: 3 maanden €9,99 voor 100% Geile amateursex.",
          },
          {
            hid: "og:url",
            name: "og:url",
            content: process.env.FE_URL + "/direct",
          },
          {
            hid: "keywords",
            name: "keywords",
            content: this.pages.direct && this.pages.direct.seo
            ? this.pages.direct.seo.keywords
            : "direct, abonnement",
          },
        ],
      };
    },
    computed: {
      ...mapState({
        pages: ({ pagesStore: { pages } }) => pages,
        video: ({ videoStore: {video} }) => video,
        subscriptions: ({ subscriptionStore: {subscriptions} }) => subscriptions,
        choices: ({ subscriptionStore: {choices} }) => choices,
        subQuery: ({ subscriptionStore: {subQuery} }) => subQuery
      }),
      // loggedIn () {
      //   if (this.$store.state.auth.loggedIn) {
      //     let subQuery = {
      //       type: 'user_id',
      //       id: this.$store.state.auth.user.id
      //     };
      //     this.$store.commit('subscriptionStore/setSubQuery', subQuery);
      //   }
      //   return this.$store.state.auth.loggedIn;
      // }
    },
    beforeCreate() {
      if (!process.client) return
        // document.documentElement.style.scrollSnapType = 'y mandatory'
      // document.documentElement.style.scrollPadding = 'var(--header-height)'
    },
  beforeDestroy() {
    document.documentElement.style.scrollSnapType = ''
    document.documentElement.style.scrollPadding = ''
  }
};
